import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '../public/static/css/liMarquee.css'

// import liMarquee from './assets/js/liMarquee.js'
// Vue.prototype.liMarquee = liMarquee;

Vue.use(ElementUI);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
